interface PrintProps {
  rootEl: HTMLAnchorElement;
}

const Print = (props: PrintProps) => {
  props.rootEl.addEventListener("click", () => {
    window.print();
  });
};

const init = () => {
  const download = document.querySelector<HTMLAnchorElement>("[h-comp='print']");
  if (!download) return;
  Print({ rootEl: download });
};

init();
